import { render, staticRenderFns } from "./ConfirmationReceipt.vue?vue&type=template&id=afd24696&scoped=true&"
import script from "./ConfirmationReceipt.vue?vue&type=script&lang=js&"
export * from "./ConfirmationReceipt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afd24696",
  null
  
)

export default component.exports